module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcCAYAAAB/E6/TAAAABHNCSVQICAgIfAhkiAAAAUxJREFUSEvt1r1Nw0AUwPH/8wJ4BMQCjsUAiJYKJiBs4FSJRQMNxDROJogp6cIEpKA/RI/ECJSA4B6yIyiIE39GkRCuz/e796G7J1yaLo7EgMt6vin9zpEwNC8IIyyz1h0HFyVBCYToQbG6T+i3D6Unj0y67+wfmpcxMofg7NH3eoV1rZ26eZdOUB0z8IP1QFemg8od6C19v1uI1GqGOkhlqC5SCbowBzjODcI9IsOFdFntMPDGS9NYuhmG5gmRnZX1+Pj0ON19zF1TGlomRCYBOcbqCaGfNI8ob4eySKUa/YaqILWhqkgtKDIBSFxYk8UMVLy9Y+PyikvoP5e6Eb4XNe66stpmoTQ9b9n8sF32wLnrVM9/XuzciFLonVFjyHK2GmoUxpKfN1ujvxFRNkA6E0SmrQdkcRGbYLUn2UicTqoiW61D2YZ6nc4XXxfSRNgsEc2oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-nav-icon-06.png
// module id = cFVM
// module chunks = 1